import React from 'react'

const Footer = () => {
  return (
    <footer className="footer text-center py-4">
			<small className="copyright">Copyright © Nhan Khang Le</small>
	</footer>
  )
}

export default Footer